<template>
  <section class="find-friend">
    <header>
      <span class="back-btn" @click="Close"><img :src="require('../../assets/images/back-icon.svg')" alt=""></span>
    </header>
    <div class="find-content">
      <span class="pulse"><img :src="require('../../assets/images/group.svg')" alt=""></span>
    </div>
    <span class="text">{{$t('Connecting')}}</span>
  </section>
</template>
<script>
export default {
  name: "NoEventFound",
  methods:{
      Close(){
          this.$emit('close')
      }
  },
  mounted(){ 
    // this.$socket.on('disconnect', () => {
    //       this.$store.commit('Reconnecting_status', 'waitingForReconnect')
    // })
  }
}
</script>